import { render } from "./EntitiesPropertiesEditView.vue?vue&type=template&id=b0272f0c"
import script from "./EntitiesPropertiesEditView.vue?vue&type=script&lang=js"
export * from "./EntitiesPropertiesEditView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__